module.exports = __webpack_public_path__ + "f9840799ab4f1505e8082ca6a961d072.svg";